import store from "../store/provider";

// The backend emits free-form English with inconsistent casing/punctuation
// ("Oops ! Invalid details." vs "Invalid Details!"), so match on a normalized form.
const normalize = (value) =>
  String(value)
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, " ")
    .trim();

const DICTIONARY = {
  "host does not found": "err_host_not_found",
  "host id is required": "err_host_id_required",
  "invalid bd id": "err_invalid_bd_id",
  "bd not found": "err_bd_not_found",
  "bd id is required": "err_bd_id_required",
  "agency not found under this bd": "err_agency_not_found_bd",
  "agency not found": "err_agency_not_found",
  "agency does not found": "err_agency_not_found",
  "agency request does not found": "err_agency_not_found",
  "previous cash out request is still pendingtry after the request is done":
    "err_redeem_pending",
  "no data found": "no_data_found",
  "you are not authorized": "err_not_authorized",
  "you are blocked by admin": "err_blocked_by_admin",
  "you are block by admin": "err_blocked_by_admin",
  "opps you are block by admin": "err_blocked_by_admin",
  "oops invalid details": "err_invalid_details",
  "invalid details": "err_invalid_details",
  "user does not found": "err_user_not_found",
  "user does not exist": "err_user_not_found",
  "user not found": "err_user_not_found",
  "coin value must be greater than 0": "err_coin_positive",
  "your account is inactive": "err_account_inactive",
  "setting does not found": "err_setting_missing",
  success: "success",
};

// Falls through to the raw string when the key has no loaded translation.
export const localizeMessage = (raw) => {
  if (typeof raw !== "string" || !raw) return raw;
  const key = DICTIONARY[normalize(raw)];
  if (!key) return raw;
  try {
    return store.getState().language.translations[key] || raw;
  } catch {
    return raw;
  }
};

export const willLocalize = (raw) =>
  typeof raw === "string" && !!DICTIONARY[normalize(raw)];

export const translationsReady = () => {
  try {
    return Object.keys(store.getState().language.translations || {}).length > 0;
  } catch {
    return true;
  }
};
